"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageActionContext = void 0;
const react_1 = require("react");
exports.MessageActionContext = (0, react_1.createContext)({});
